(function () {
  'use strict';

  d3.chart('ChartBase').extend('ReturnsPerformanceChart', {
    initialize : function (options) {
      var plot = this;
      options = options || {};

      _.defaultsDeep(options, {
        barThickness : 30,
        axisWidth : 25
      });
      var AXIS_WIDTH = options.axisWidth;
      var LABEL_WIDTH_RATIO = 0.05;
      var DEFAULT_PAGE_LENGTH = 100;
      var SIZE_ADVICE_COLOR = '#7C0A40';
      var PLOT_LINE_BAR_COLOR = '#DBDBDB';
      var SIZE_ADVICE_WIDTH = 7 ;
      var SIZE_ADVISE_THICKNESS = 15;
      var Y_MARKER_COORDINATE = 47.5;
      var MARKER_ADJUSTMENT = 6;
      var CONST_ADDITIONAL_HEIGHT = 100;
      var CARET_DOWN = '\uf0d7';
      var CARET_UP = '\uf0d8';
      var CROSS_ICON = '\uf00d';

      var THICKNESS = 'height';
      var LENGTH = 'width';
      var PADDING = 20;
      var HALF_THICKNESS = options.barThickness / 2;
      var KEY_WIDTH = 10;

      plot.bucket = d3.scale.ordinal();
      plot.value = d3.scale.linear();

      function getAllowedLength(label) {
        return label === 'Two' ? 16 : 32;
      }

      plot.layers = {
        labels : {
          performanceCategoryLabel : plot.wrap.append('g').classed('performanceCategoryLabel',true),
          dataNameLabel : plot.wrap.append('g').classed('dataNameLabel', true),
          dataTitleLabel : plot.wrap.append('g').classed('dataTitleLabel', true),
          labelFour:plot.wrap.append('g').classed('labelFour',true),
        },
        bars: {
          plotLine:plot.wrap.append('g').classed('plotLine',true)
        }
      };

      function setYTranslate(bucketPos) {
        return bucketPos + AXIS_WIDTH;
      }

      function appendText(group, elem) {
        return group.append(elem).classed('bar-label-text', true)
            .attr('alignment-baseline', 'middle')
            .attr('font-family', 'Gotham, sans-serif')
      }

        plot.layer('performanceCategoryLabel', plot.layers.labels.performanceCategoryLabel, {
        dataBind : function (data) {
          return this.selectAll('.label-group')
              .data(data.page);
        },
        insert : function () {
          var group = this.append('g').classed('label-group', true);
          group.append('rect');
          group.on("mouseover", handleMouseOver)
              .on("mouseout",handleMouseOut)
              .on("click",handleOnClick);
          return group;
        },
        events : {
          exit : function () {
            this.remove();
          },
          merge : function () {
            var that = this;
            var additionalWidth = 0;
            var includeWidth = false;
            that.translate(origDatum(function (item, index) {
              var bucketPos = byBucket.apply(this, arguments);
              if(includeWidth){
                additionalWidth += CONST_ADDITIONAL_HEIGHT;
              }
              includeWidth = item.isSizeAdviceEnable;
              return [0, setYTranslate(bucketPos) + additionalWidth];
            }));

            var rect = that.select('rect');
            rect.style(THICKNESS, HALF_THICKNESS)
                .style(LENGTH, KEY_WIDTH)
                .attr('x',HALF_THICKNESS)
                .attr('y',HALF_THICKNESS/2)
                .attr('class',function (datumRankPair) {
                  return plot.fn.keyColor(datumRankPair[0].performanceCategoryLabel);
                });
          }
        }
      });

      plot.layer('dataNameLabel', plot.layers.labels.dataNameLabel, {
        dataBind : function (data) {
          return this.selectAll('.label-group')
              .data(data.page);
        },
        insert : function () {
          var group = this.append('g').classed('label-group', true);
          group.on("mouseover", handleMouseOver)
              .on("mouseout",handleMouseOut)
              .on("click",handleOnClick);
          var text = group.append('text');
          text.append("title");
          appendText(text, 'tspan');

          appendText(group, 'text').classed('caretClass', true).append('tspan')
              .classed('fa',true).classed('display-none',true)
              .attr('alignment-baseline', 'middle')
              .text(CARET_DOWN);

          return group;
        },
        events : {
          exit : function () {
            this.remove();
          },
          merge : function () {
            var that = this;
            var allowedLength = getAllowedLength('Two');
            var labelXPos = labelWidth(plot.w);

            var text = that.select('text');

            text.select('title').text(function(dataRankPair){
              return plot.fn.dataNameLabel(dataRankPair[0]);
            });

            var additionalWidth = 0;
            var includeWidth = false;

            that.select('.caretClass').attr("id", function (dataRankPair) {
              return "caret"+ dataRankPair[1];
            });

            that.translate(origDatum(function (item, index) {
              if(!item.isSizeAdviceEnable && !_.isUndefined(item.sizeAdvice)) {
                d3.select(this).selectAll('.caretClass').select('tspan')
                    .attr('x', d3.select('svg').selectAll('.bar-label-text').node().getBBox().width + PADDING / 2)
                    .attr('y', HALF_THICKNESS)
                    .classed('display',true)
                    .style("cursor", "pointer");
              }
              var bucketPos = byBucket.apply(this, arguments);
              if(includeWidth){
                additionalWidth += CONST_ADDITIONAL_HEIGHT;
              }
              includeWidth = item.isSizeAdviceEnable;
              return [labelXPos + PADDING, setYTranslate(bucketPos) + additionalWidth]
            }));

            text.select('tspan')
                .text(function (datumRankPair) {
                  var rankLabel = plot.fn.dataNameLabel(datumRankPair[0]);
                  if (!plot.data.dontRank) {
                    rankLabel = datumRankPair[1] + '. ' + rankLabel;
                  }
                  return rankLabel;
                })
                .attr('y', HALF_THICKNESS)
                .classed('no-border', true)
                .attr(THICKNESS, options.barThickness)
                .attr(LENGTH, labelWidth(plot.w)*2)
                .each(wrapText(allowedLength));
          }
        }
      });

      function handleMouseOver(dataRankPair) {
        if(!_.isUndefined(plot.fn.sizeAdvice(dataRankPair[0]))) {
          d3.select(this).select('text').select('tspan').style("cursor", "pointer");
        }
      }

      function handleMouseOut(dataRankPair) {
        if(!_.isUndefined(plot.fn.sizeAdvice(dataRankPair[0]))) {
          d3.select(this).select('g').style("cursor", "default");
        }
      }

      function handleOnClick(dataRankPair) {
        if(!plot.fn.isSizeAdviceEnable(dataRankPair[0]) && (!_.isUndefined(plot.fn.sizeAdvice(dataRankPair[0])))) {
          d3.select('svg').select('#caret' + dataRankPair[1]).select('tspan').text(CARET_UP);
          d3.select(this).datum()[0].isSizeAdviceEnable = true;
          plot.fn.changeChartHeight(dataRankPair);
        } else {
          if(plot.fn.isSizeAdviceEnable(dataRankPair[0])){
            d3.select('svg').select('#caret' + dataRankPair[1]).select('tspan').text(CARET_DOWN);
            closeSizeAdviceTip(dataRankPair);
         }
        }
      }


      plot.layer('dataTitleLabel', plot.layers.labels.dataTitleLabel, {
        dataBind : function (data) {
          return this.selectAll('.label-group')
              .data(data.page);
        },
        insert : function () {
          var group = this.append('g').classed('label-group', true);
          group.on("mouseover", handleMouseOverStyleName)
              .on("mouseout",handleMouseOutFromStyleName)
              .on("click",handleMouseClickOverStyleName);
          var text = group.append('text');
          text.append('title');
          appendText(text, 'tspan');

          return group;
        },
        events : {
          exit : function () {
            this.remove();
          },
          merge : function () {
            var that = this;
            var labelXPos = labelWidth(plot.w) * 3 + PADDING;
            var allowedLength = getAllowedLength('Three');
            var additionalWidth = 0;
            var includeWidth = false;

            that.translate(origDatum(function (item, index) {
              var bucketPos = byBucket.apply(this, arguments);
              if(includeWidth){
                additionalWidth += CONST_ADDITIONAL_HEIGHT;
              }
              includeWidth = item.isSizeAdviceEnable;
              return [labelXPos + PADDING * 2, setYTranslate(bucketPos) + additionalWidth];
            }));


            var text = that.select('text');

            text.select('title').text(function(datumRankPair){
              return plot.fn.dataTitleLabel(datumRankPair[0]);
            });

            text.select('tspan')
                .text(function (datumRankPair) {
                  return plot.fn.dataTitleLabel(datumRankPair[0]);
                })
                .attr('id',function (datumRankPair) {return 'dataLabel' + datumRankPair[1];})
                .attr('y', HALF_THICKNESS)
                .classed('no-border', true)
                .attr(THICKNESS, options.barThickness)
                .attr(LENGTH, labelWidth(plot.w) * 4)
                .each(wrapText(allowedLength));
          }
        }
      });

      function handleMouseOverStyleName(datumRankPair) {
        if(plot.data.isProductDetailAccessible) {
          d3.select(this).select('text').select('tspan').style("cursor", "pointer");
          d3.select(this).select('#dataLabel'+ datumRankPair[1]).attr('text-decoration','underline');
        }
      }

      function handleMouseOutFromStyleName(datumRankPair) {
        d3.select(this).select('text').select('tspan').style("cursor", "default");
        d3.select(this).select('#dataLabel'+ datumRankPair[1]).attr('text-decoration','none');
      }

      function handleMouseClickOverStyleName(datumRankPair) {
        if (plot.data.isProductDetailAccessible) {
          showProductDetail(datumRankPair);
        }
      }

      plot.layer('labelFour', plot.layers.labels.labelFour, {
        dataBind : function (data) {
          return this.selectAll('.label-group')
              .data(data.page);
        },
        insert : function () {
          var group = this.append('g').classed('label-group', true);
          group.on("mouseover", handleMouseOver)
              .on("mouseout",handleMouseOut)
              .on("click",handleOnClick);
          var text = group.append('text');
          text.append("title");
          appendText(text, 'tspan');

          return group;
        },
        events : {
          exit : function () {
            this.remove();
          },
          merge : function () {
            var that = this;
            var allowedLength = getAllowedLength();
            var text = that.select('text');
            var additionalWidth = 0;
            var includeWidth = false;

            text.select('title').text(function(dataRankPair){
              return (dataRankPair[0].performanceCategoryLabel !== "") ? plot.fn.performanceCategoryLabel(dataRankPair[0])+'%' : "";
            });

            text.select('tspan')
                .text(function (datumRankPair) {
                  var rankLabel = (datumRankPair[0].performanceCategoryLabel !== "") ? plot.fn.performanceCategoryLabel(datumRankPair[0])+'%' : "";
                  return rankLabel;
                })
                .attr('x', 0)
                .attr('y', HALF_THICKNESS)
                .classed('no-border', true)
                .attr(THICKNESS, options.barThickness)
                .attr(LENGTH, labelWidth(plot.w) * 4)
                .each(wrapText(allowedLength));

            that.translate(origDatum(function (item, index) {
              var bucketPos = byBucket.apply(this, arguments);
              var labelXPos = labelWidth(plot.w) * 4 + PADDING;
              if(_.isUndefined(plot.fn.dataTitleLabel(item))){
                labelXPos = labelWidth(plot.w) * 3 - PADDING;
              }
              if(includeWidth){
                additionalWidth += CONST_ADDITIONAL_HEIGHT;
              }
              includeWidth = item.isSizeAdviceEnable;
              return [labelXPos + PADDING, setYTranslate(bucketPos) + additionalWidth]
            }));

          }
        }
      });

      plot.layer('plotLine', plot.layers.bars.plotLine,{
        dataBind : function (data) {
          return this.selectAll('.bucket')
              .data(data.page);
        },
        insert : function () {

          var group = this.append('g').classed('bucket', true);
          var path = group.append('g').append('path').classed('indicator',true).attr({
            'stroke' :"rgba(0,0,0,.2)",
            'fill':'none'
          });
          appendText(group, 'text').attr('font-family', 'GothamMedium, sans-serif');
          group.append('text').style('cursor','pointer').classed('cross',true).append('tspan')
              .classed('fa',true)
              .attr('alignment-baseline', 'middle')
              .text(CROSS_ICON);
          var labelGroup = group.append('g');
          appendText(labelGroup, 'text').classed('runs-small-text', true);
          appendText(labelGroup, 'text').classed('runs-true-text', true);
          appendText(labelGroup, 'text').classed('runs-large-text', true);

          var transactionLabel = group.append('g');
          appendText(transactionLabel, 'text').classed('transactions',true);
          appendText(transactionLabel, 'text').classed('navigate-product-detail',true);
          appendText(transactionLabel,'text')
              .classed('info',true).classed('fa',true)
              .text(function(d) { return '\uf05a' });
          group.append('rect').classed('bar', true);
          return group;
        },
        events : {
          exit : function () {
            this.remove();
          },
          merge : function () {
              var bucket = this;
              var labelXPos = labelWidth(plot.w);
              var fullBarLength = plot.value.range()[1];
              var popoverWidth = fullBarLength + 30;
              var additionalWidth = 0;
              var includeWidth = false;
              var sizeAdviceLabelsYCor = 40;
              var leftPadding = 15;
              var yCoordinate = 15;

              bucket.translate(origDatum(function (item, index) {
                    var bucketPos = byBucket.apply(this, arguments);
                    if(includeWidth){
                      additionalWidth += CONST_ADDITIONAL_HEIGHT;
                    }
                    includeWidth = item.isSizeAdviceEnable;
                    return [labelXPos + PADDING, setYTranslate(bucketPos) + PADDING * 1.7 + additionalWidth];})
                  )
                  .style('display',function (dataRankPair) {
                    return (plot.fn.isSizeAdviceEnable(dataRankPair[0])) ? "block":"None";
                  });

              var barBg = bucket.select('.bar')
                  .classed('even', true)
                  .attr(THICKNESS, 10)
                  .attr(LENGTH, fullBarLength)
                  .style('fill', PLOT_LINE_BAR_COLOR)
                  .translate(leftPadding, sizeAdviceLabelsYCor + 10);

              bucket.select('.indicator').attr({LENGTH:fullBarLength + 30,
                'd':'M29,-11 L12,0 -8,0 -8,100 '+ popoverWidth +',100 ' + popoverWidth +',0 48,0 z',
              });

              bucket.select('.bar-label-text')
                .text(function (datumRankPair) {
                  var rankLabel = plot.fn.dataTitleLabel(datumRankPair[0]);
                  return rankLabel;})
                  .attr('x', leftPadding - 5)
                  .attr('y', yCoordinate)
                  .classed('no-border', true)
                  .attr(THICKNESS, options.barThickness);

              bucket.select('.cross').select('tspan').attr('x',fullBarLength).attr('y',yCoordinate).on("click",closeSizeAdviceTip);

              bucket.select('.runs-small-text').text('RUNS SMALL')
                  .attr('x', leftPadding - 5)
                  .attr('y', sizeAdviceLabelsYCor)
                  .classed('no-border', true)
                  .attr(THICKNESS, options.barThickness);

            bucket.select('.runs-true-text').text('TRUE TO SIZE')
                .attr('x', fullBarLength / 2 - 30)
                .attr('y', sizeAdviceLabelsYCor)
                .classed('no-border', true)
                .attr(THICKNESS, options.barThickness);

            bucket.select('.runs-large-text').text('RUNS LARGE')
                .attr('x', fullBarLength - 60)
                .attr('y', sizeAdviceLabelsYCor)
                .classed('no-border', true)
                .attr(THICKNESS, options.barThickness);

            bucket.select('.transactions').text('Based on 100s of transactions')
                .attr('x', leftPadding - 5)
                .attr('y', sizeAdviceLabelsYCor * 2 + PADDING / 2)
                .classed('no-border', true)
                .attr(THICKNESS, options.barThickness);

            bucket.select('.navigate-product-detail').text('More about this product')
                .attr('x', fullBarLength - 120)
                .attr('y', sizeAdviceLabelsYCor * 2 + PADDING / 2)
                .classed('no-border', true)
                .classed('display-none',!plot.data.isProductDetailAccessible)
                .attr(THICKNESS, options.barThickness)
                .on("click",showProductDetail);

            bucket.select('.info')
                .attr('x', bucket.select('.transactions').node().getBBox().width + PADDING)
                .attr('y', sizeAdviceLabelsYCor * 2 + PADDING / 2)

              var group = bucket.selectAll('.bar-grp')
                  .data(plot.markers);

              group.exit().remove();

              var newGroups = group.enter()
                  .append('g').classed('bar-grp', true);

              newGroups.append('rect')
                  .classed('marker', true);

              var temp = plot;
              temp.value.domain([0, 4]);

              group.select('.marker')
                  .attr(THICKNESS, SIZE_ADVISE_THICKNESS)
                  .attr(LENGTH, SIZE_ADVICE_WIDTH / 2)
                  .attr('fill', PLOT_LINE_BAR_COLOR)
                  .translate(function (item, index) {
                    return [temp.value(index) + 2 * MARKER_ADJUSTMENT, Y_MARKER_COORDINATE];
                  });

              newGroups.append('rect')
                  .classed('sizeAdvice', true);

              group.select('.sizeAdvice')
                  .attr(THICKNESS, SIZE_ADVISE_THICKNESS)
                  .attr(LENGTH, SIZE_ADVICE_WIDTH)
                  .attr('fill', SIZE_ADVICE_COLOR)
                  .translate(function (d, i, j) {
                    if(plot.data.page[j][0].isSizeAdviceVisible) {
                      return [temp.value((plot.data.page[j][0].sizeAdvice + 2)) + 2 * MARKER_ADJUSTMENT, Y_MARKER_COORDINATE];
                    }else return [0,Y_MARKER_COORDINATE];
                  });
            }
        }
      });

      function closeSizeAdviceTip(dataRankPair) {
        d3.select(this).select('.bucket').remove();
        d3.select('svg').select('#caret' + dataRankPair[1]).select('tspan').text(CARET_DOWN);
        _.forEach(plot.data.data,function (value) {
          if(dataRankPair[1] == value[1]) {
            value[0].isSizeAdviceEnable = false;
          }
        });
        handleMouseOut(dataRankPair);
        plot.fn.changeChartHeight(dataRankPair);
      }
      // We wrap the original datum in an array with its rank.
      // This augments the given function to just get the datum
      function origDatum(fn) {
        return function (datumRankPair, i, j, k) {
          return fn.call(this, datumRankPair[0], i, j, k);
        };
      }

      // TODO - move this to a common file
      function wrapText(limitChar) {
        return function(){
          var self = d3.select(this),
              text = self.text();

          if(text.length > limitChar){
            self.text(_.truncate(text,{
              'length': limitChar
            }));
          }
        };
      }

      function byBucket(item, index) {
        return plot.bucket(index);
      }

      function labelWidth(plotWidth){
        return (plotWidth - KEY_WIDTH) * LABEL_WIDTH_RATIO;
      }

      function plotLayers() {
        _.each(plot.layers.labels,function (label) {
          label.draw(plot.data);
        });
        plot.layers.bars.plotLine.draw(plot.data);
      }

      function calcRange() {
        var labelXWidth = labelWidth(plot.w) * 7;
        var sizeAdviceCount =0;
        _.forEach(plot.data.data, function (value) { if (value[0].isSizeAdviceEnable) {
            sizeAdviceCount++;
          }
        });
        plot.bucket.rangeRoundBands([0, plot.h - AXIS_WIDTH - (CONST_ADDITIONAL_HEIGHT * sizeAdviceCount)], 0, 0.4);
        // Draw labels so we can accurately calculate their maximum size.
        // This needs to be done AFTER setting the bucket.range to avoid an exception.
        plot.value.range([0, Math.max((plot.w - labelXWidth - PADDING), 0)]);
        plotLayers();
        plot.layers.labels.labelFour.translate(labelXWidth, 0);
        d3.select("svg").select("g").translate(0, (plot.data.page.length !== DEFAULT_PAGE_LENGTH) ? - 2 * PADDING : - (3 * PADDING + PADDING / 2));
      }

      function showProductDetail(datumRankPair){
        var styleId = datumRankPair[0].dataNameLabel;
        plot.fn.navigateProductDetailPage(styleId);
      }

      plot.on('change:width', calcRange)
          .on('change:height', calcRange)
          .on('change:data', calcRange);
    },

    valuesArray : function (item, edge) {
      if(edge === 'leftEdge')
        return this.fn.leftEdge.map(function (fn) {
          return fn(item);
        });
      else if(edge === 'rightEdge')
        return this.fn.rightEdge.map(function (fn) {
          return fn(item);
        });
      else return this.fn.returnVariationData.map(function (fn) {
          return fn(item);
        });
    },
    transform : function (data) {
      var plot = this;

      if (data !== plot.data) {
        _.defaults(data, {
          fn : {},
          pageSize : data.data.length,
          currentPage : 1
        });
        plot.fn = _.defaults(data.fn, {
          performanceCategoryLabel : _.property('performanceCategoryLabel'),
          dataNameLabel : _.property('dataNameLabel'),
          returnVariationData : _.property('returnVariationData'),
          leftEdge : _.property('leftEdge'),
          rightEdge : _.property('rightEdge'),
          sizeAdvice: _.property('sizeAdvice'),
          color : ["#7C0A40"]
        });
        _.defaults(data.fn, {
          valueLabel : data.fn.valueLabel,
          changeHeight: data.fn.changeHeight
        });
        if (!_.isArray(plot.fn.returnVariationData)) {
          plot.fn.returnVariationData = [plot.fn.returnVariationData];
        }
        if (!_.isArray(plot.fn.leftEdge)) {
          plot.fn.leftEdge = [plot.fn.leftEdge];
        }
        if (!_.isArray(plot.fn.rightEdge)) {
          plot.fn.rightEdge = [plot.fn.rightEdge];
        }
        if (!_.isArray(plot.fn.valueLabel)) {
          plot.fn.valueLabel = [plot.fn.valueLabel];
        }
        if(!_.isArray(plot.fn.color)){
          plot.fn.color = [plot.fn.color];
        }

        var sumOfAllValues = function (item, edge) {
          return _.sum(plot.valuesArray(item, edge));
        };

        var sumOfLeftEdge = function(item) {
          return sumOfAllValues(item, 'leftEdge');
        };

        var sumOfRightEdge = function(item) {
          return sumOfAllValues(item, 'rightEdge');
        };

        var leftMin = d3.min(data.data, sumOfLeftEdge);
        var rightMax = d3.max(data.data, sumOfRightEdge);
        var maxIntermediate = Math.abs(leftMin) > rightMax ? Math.abs(leftMin) : rightMax;

        /*While refining maxIntermediate threshold should be kept as high as 0.015 in the least as below that the number is rounded off to
          a number less than or equal to one and then since it is tried to derive five ticks out of it markers repeat. Same is true for
          the value and that too can't go lower than 0.02 for the same reason.*/
        var max = maxIntermediate < 0.02 ? 0.02 : maxIntermediate;

        plot.value.domain([-1 * max, max]).nice();

        // setup a lazily evaluated chain of transformations
        var dataChain = _(data.data);

        // Hold onto the original ranking number, or else it'd be erased when filtering or paging
        dataChain = dataChain.map(function (d, i) {
          return [d, i + 1];
        });

        // Support for arbitrary filtering
        if (data.fn.filter) {
          dataChain = dataChain.filter(function (item, i) {
            return data.fn.filter(item[0], i);
          });
        }

        // Finally evaluate the chain of transformations above to a concrete values
        data.data = dataChain.value();

        data.page = data.data.slice((data.currentPage - 1) * data.pageSize, data.currentPage * data.pageSize);

        plot.bucket.domain(d3.range(data.page.length));

        plot.data = data;

        plot.markers=[-2, -1, 0, 1, 2];
      }

      return data;
    }
  });

})();